<app-base-list [listTitle]="'HOME.ACTIVITY_FEED.TITLE' | transloco">
  <ng-container *ngIf="!busy; else loadingState">
    <ng-container *ngIf="activities.length > 0; else emptyState">
      <app-item-list 
        *ngFor="let activity of this.activities"
        [iconPath]=" activity.isPositive ? 'assets/icons/arrow_up.svg' : 'assets/icons/arrow_down.svg'"
        [iconColor]="activity.isPositive ? IonicColorEnum.SUCCESS : IonicColorEnum.DANGER"
        [subtitle]="'HOME.ACTIVITY_FEED.' + activity.transactionType | transloco"
        [title]="activity.attributes.totalEuroValue | currency : 'EUR' : 'symbol' : '1.0-2'"
        [titleColor]="activity.isPositive ? IonicColorEnum.SUCCESS : IonicColorEnum.DANGER"
        [note]="activity.attributes.displayDate | date : 'd MMM y'"
      />
    </ng-container>
  </ng-container>
  <ng-template #loadingState>
    <app-item-list [busy]="busy" *ngFor="let _ of [].constructor(5)" />
  </ng-template>
  <ng-template #emptyState>
    <ion-item color="light" class="text-center">
      <ion-label class="p-8">{{ "WALLET.DETAILS.EMPTY" | transloco }}</ion-label>
    </ion-item>
  </ng-template>
</app-base-list>